import React from 'react';
import { useTranslation } from 'react-i18next';
import { CrossIcon } from '@common_components/icons/cross.icon';
import { QuestionMarkIcon } from '@common_components/icons/questionMark.icon';
import Button from '@common_components/buttons/button.component';
import ModalButton from '@common_components/buttons/modalButton.component';
import { EventCommitment } from 'interfaces/types.interface';

interface EventCompletionModalProps {
  isVisible: boolean;
  eventDroped: EventCommitment | null | undefined;
  onClose: () => void;
  onConfirmNo: () => void;
  onConfirmYes: () => void;
}

const EventCompletionModal: React.FC<EventCompletionModalProps> = ( {
  isVisible,
  eventDroped,
  onClose,
  onConfirmNo,
  onConfirmYes
} ) => {
  const { t } = useTranslation();

  if ( !isVisible || !eventDroped ) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div className="absolute inset-0 bg-black appear bg-opacity-40" />
      <div className="relative bg-white-base flex-col gap-4 rounded-xl flex shadow-xl p-6 w-full max-w-md z-[110]">
        <Button
          icon={
            <CrossIcon className="group-hover:rotate-[360deg] transition-transform duration-700" size={7} />
          }
          color="absolute right-0 top-0 m-4 bg-transparent"
          colorHover="hover:bg-red-200"
          textColorHover="hover:text-red-base"
          hoverBorderColor="hover:border-transparent"
          textSize="text-xl"
          roundedRadius='rounded-xl'
          shadow="hover:shadow-md"
          onClick={onClose}
        />
        <div className='flex gap-5 flex-center w-fit'>
          <div className='p-1 bg-blue-100 rounded-full text-blue-600 w-fit h-fit aspect-square'>
            <QuestionMarkIcon size={9} />
          </div>
          <h2 className="text-xl font-semibold mb-2">{ t( 'translation:question' ) }</h2>
        </div>
        <div>
          <p className="text-gray-700 mb-6">{ t( 'translation:is_this_event_over' ) }</p>
          <div className="flex justify-end gap-4">
            <div className="flex gap-4">
              <ModalButton
                label={ t( 'common:no' ) }
                onClick={onConfirmNo}
                textColor="text-white"
                shadow='shadow-none'
                bgColor="bg-red-600"
                borderColor="border-transparent"
                hoverBorderColor="hover:border-red-600"
              />
              <ModalButton
                label={ t( 'common:yes' ) }
                onClick={onConfirmYes}
                textColor="text-white"
                shadow='shadow-none'
                bgColor="bg-green-600"
                borderColor="border-transparent"
                hoverBorderColor="hover:border-green-600"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCompletionModal;
